import { inject } from '@angular/core';
import { MyRouter } from '../../../common/services/router.service';
import { AppConfigService } from '../app-config.service';

export const instanceAuthenticatedGuard = () => {
    const router = inject(MyRouter);
    const appConfigService = inject(AppConfigService);

    if (appConfigService.getAppConfig().opCo === 'BE01') {
        return true;
    } else {
        router.navigateToLogin();
        return false;
    }
}
